import { cn } from '@/lib'
import { type VariantProps, cva } from 'cva'

export const headingVariants = cva({
	base: 'font-bold',
	variants: {
		level: {
			'1': 'text-3xl',
			'2': 'text-2xl',
			'3': 'text-xl',
			'4': 'text-2lg',
			'5': 'text-lg',
		},
		transform: {
			uppercase: 'uppercase tracking-wider',
			capitalize: 'capitalize',
			lowercase: 'lowercase',
			none: 'normal-case',
		},
		font: {
			mono: 'font-mono',
			sans: 'font-sans',
			brand: 'font-serif font-normal',
		},
		color: {
			default: '',
			caption: 'text-gray-400',
			error: 'text-red-700',
		},
		align: {
			default: '',
			left: 'text-left',
			center: 'text-center',
			right: 'text-right',
		},
	},
	defaultVariants: {
		level: '1',
		transform: 'none',
		font: 'sans',
		color: 'default',
		align: 'default',
	},
})

export interface HeadingProps
	extends Omit<React.HTMLAttributes<HTMLHeadingElement>, 'color'>,
		VariantProps<typeof headingVariants> {}

export const Heading: React.FC<HeadingProps> = ({
	className,
	level,
	transform,
	font,
	color,
	align,
	...props
}) => {
	const Tag = `h${level || '1'}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5'
	return (
		<Tag
			className={cn(
				headingVariants({ level, transform, font, color, align }),
				className,
			)}
			{...props}
		/>
	)
}
